import { useState } from "react";

export default function ConsentModal({ onClose, onAgree }: any) {

  const [check, setCheck] = useState(false);

  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50 tw-px-4 tw-py-6">

      <div className="tw-bg-white tw-w-full tw-max-w-xl tw-rounded-2xl tw-p-5 md:tw-p-8 tw-space-y-4 tw-max-h-[92vh] tw-overflow-y-auto">

        <h2 className="tw-text-xl tw-font-bold">
          'N-Pass' 서비스 이용 및 보안 서약
        </h2>

        <div className="tw-border tw-rounded-lg tw-p-4 tw-h-[340px] md:tw-h-[420px] tw-overflow-y-auto tw-text-sm tw-text-slate-600 tw-mb-2">
          <p className="tw-font-semibold">['N-Pass' 서비스 이용 및 보안 서약]</p>

          <p className="tw-mt-2">
            본 기능을 활성화하면 비즈팅이 수집한 메시지 수신자의 개인정보를 제 3자 제공받아 처리하게 됩니다.
            안전한 데이터 활용을 위해 아래 보안 사항에 서약해 주시기 바랍니다.
          </p>

          <ul className="tw-mt-2 tw-list-disc tw-pl-5">
            <li>
              기술적 보호: 개인정보보호법 제 29조에 따른 안전성 확보조치를 이행하겠습니다.
              또한 계정의 2단계 인증(이메일 인증)을 필수 적용하며,
              내부 접근 권한을 최소화하여 관리하겠습니다.
            </li>
            <li>
              목적 외 사용 및 재제공 금지: 비즈팅으로부터 제 3자 제공받은 정보를 명시된 마케팅 및
              관심고객모집 기능 목적 외로 사용하거나 외부에 유출하지 않겠습니다.
              제공받은 개인정보를 제3자에게 재제공하거나 처리를 재위탁하지 않겠습니다.
            </li>
            <li>
              데이터 파기: 이용 목적이 달성되거나 유저가 동의를 철회한 경우,
              관련 법령에 따라 5일 이내에 복구 불가능한 방법으로 파기하겠습니다.<br/><br/>

              메시지 수신자의 파기 요청이 접수될 경우, 비즈팅 시스템 내 해당 정보는 최대 4일 이내 복구 불가능한 방법으로 삭제됩니다.<br/><br/>

              또한 고객사가 기존에 다운로드한 엑셀 파일 등에는 즉시 반영되지 않으므로, 파기 요청 접수 시 고객사에 별도 안내를 통해 최신 데이터를 재다운로드하도록 요청하며, 기존 보유 데이터는 즉시 파기해야 합니다.<br/><br/>

              고객사는 상기 내용을 충분히 인지하였으며, 이에 따른 데이터 관리 및 파기 절차를 준수할 것에 동의합니다.
            </li>
            <li>
              사고 통지 및 조사 협조 : 제공받은 데이터와 관련하여 유출 등 침해사고가 발생하거나 의심되는 경우
              지체 없이 비즈팅에 통보하며, 피해 최소화 및 관련 감독기관 조사에 적극 협조하겠습니다.
            </li>
            <li>
              책임 귀속 : 당사(고객사)는 독립된 개인정보처리자로서 제공받은 데이터 활용에 대한 모든 법적 책임을 부담하며,
              당사의 고의·과실 또는 관련 법령 위반으로 인해 발생한 사고나 분쟁에 대해 비즈팅은 면책됨에 동의합니다.
            </li>
            <li>
              본 서약에 대한 동의는 체크박스 클릭 방식의 전자적 동의로 이루어지며,
              동의 완료 시 본 서약의 모든 조항에 동의한 것으로 간주합니다.
            </li>
          </ul>

          <p className="tw-mt-2">
            본 제공은 제 3자 제공으로 이루어지며, 정보주체의 동의를 기반으로 고객사에게 제공됩니다.
          </p>
        </div>

        <div className="tw-border tw-text-slate-600 tw-px-1 tw-mt-0">
          <label className="tw-flex tw-items-center tw-gap-2">
            <input
                type="checkbox"
                checked={check}
                onChange={(e) => setCheck(e.target.checked)}
            />
            개인정보 수집 및 이용에 동의합니다.
          </label>
        </div>

        <div className="tw-flex tw-justify-end tw-gap-3">
          <button
            onClick={onClose}
            className="tw-border tw-px-4 tw-py-2 tw-rounded-lg tw-border-0"
          >
            취소
          </button>
          <button
            disabled={!check}
            onClick={onAgree}
            className="tw-bg-[#5D87FF] tw-text-white tw-px-6 tw-py-2 tw-rounded-lg disabled:tw-opacity-40 tw-border-0"
          >
            동의하고 시작
          </button>
        </div>

      </div>

    </div>
  );
}
